﻿const emailPattern = /^[^\s@]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/
const digitsOnly = value => String(value ?? '').replace(/\s/g, '')

export default  {
    requiredTrueFalse: v => (v === true || v === false) || 'This field is required',
    required: value => !!value || 'This field is required',
    requiredDeclaration: value => !!value || 'You must agree to this declaration',
    ndisNumber: value => /^\d{9}$/.test(value) || 'NDIS number must be exactly 9 digits.',
    fundingAmount: value => {
        const amount = Number(value)
        return (value !== '' && Number.isFinite(amount) && amount >= 0)
            || 'Funding amount must be zero or greater.'
    },
    email: value => emailPattern.test(value) || 'E-mail must be valid.',
    optionalEmail: value => !value || emailPattern.test(value) || 'E-mail must be valid.',
    mobile: value => /^04\d{8}$/.test(digitsOnly(value)) || 'Mobile number must contain 10 digits and begin with 04.',
    phone: value => /^\d{8,15}$/.test(digitsOnly(value)) || 'Phone number must contain 8 to 15 digits.',
    optionalPhone: value => !value || /^\d{8,15}$/.test(digitsOnly(value)) || 'Phone number must contain 8 to 15 digits.'
}
